import _get from "lodash/get";
import _keyBy from "lodash/keyBy";

/**
 * This file contains redux selectors for accessing section related data
 */

/**
 * Return the list of sections in the current newsletter (BE filters sections w/out articles)
 * @param state
 * @returns {*}
 */
export const getSections = (state) => {
    return _get(state, "newsletters.currentData.data.sectionList", []);
    //return _.filter(allSections, (section) => (_get(section, "giList.length") > 0));
};

/**
 * A hash map of sections (by ID)
 * @param state
 * @returns {*}
 */
export const getSectionHashMap = (state) => {
    const sections = getSections(state);
    return _keyBy(sections, "id");
};

/**
 * Return the section data for a section in the current newsletter
 * @param state
 * @param id
 * @returns {*}
 */
export const getSectionData = (state, id) => {
    const hashMap = getSectionHashMap(state);
    return _get(hashMap, id, {});
};

/**
 * Return the section id for a section in the current newsletter
 * @param {*} state
 * @param {number} id
 * @returns {number}
 */
export const getSectionId = (state, id) => {
    const data = getSectionData(state, id);
    return _get(data, "id", "");
};

/**
 * Return the section groupingSectionId for a section in the current newsletter
 * @param {*} state
 * @param {number} id
 * @returns {number}
 */
export const getSectionGroupingSectionId = (state, id) => {
    const data = getSectionData(state, id);
    return _get(data, "groupingSectionId", "");
};


/**
 * Return the section anchor id for a section in the current newsletter
 * @param {*} state
 * @param {Number} id - section id
 * @returns {*}
 */
export const getSectionAnchorId = (state, id) => {
    const uid = getSectionGroupingSectionId(state, id);
    return `section_${uid}`;
};

/**
 * get subsections for given section
 * @param  {} state
 * @param  {Number} sectionId
 * @return {Array} - list of subsections. empty if subsections don't exist
 */
export const getSubSections = (state, sectionId) => {
    const sectionData = getSectionData(state, sectionId);

    return _get(sectionData, "subSections", []);
};
